import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import vuePositionSticky from 'vue-position-sticky'
import VueCodeHighlight from 'vue-code-highlight';

import VueMask from 'v-mask'
Vue.use(VueMask)
 

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueCarousel from 'vue-carousel';

Vue.use(VueCarousel);

Vue.use(VueCodeHighlight);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(vuePositionSticky)

export const eventBus = new Vue();
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
